import axios from 'axios';
import APIS from '../apiUrl';
import { requireAuthHeaders } from '../auth/getAuthToken';

export const deleteLog = async (logId: string): Promise<void> => {
  await axios({
    method: 'POST',
    url: `${APIS.SENTINEL_API}/api/logs/delete`,
    headers: await requireAuthHeaders(),
    data: {
      _id: logId,
    },
  });
};
